import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    padding: 20px 20px 27px 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 330px;

    @media (max-width: 768px) {
        width: 100%;
        padding: 24px 20px 5px 20px;
        box-shadow: 0px 10px 10px #090719;
        z-index: 9;
        position: relative;
    }
`;

export const YatLogoLink = styled(Link)<{ $isMinimized?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    transform: translateX(3px) translateY(-4px);

    img {
        width: 62px;
    }

    svg {
        width: 22px;
    }

    ${({ $isMinimized }) =>
        $isMinimized &&
        css`
            width: 46px;
            height: 46px;
            color: #fff;
            margin-bottom: -20px;
        `}

    @media (max-width: 768px) {
        transform: translateX(3px) translateY(-1px);
    }
`;
